import React from 'react';

export const Blank = () => {
  return <div className='blank' />;
};
